const bazarListBn = {
	banner: {
		title: 'বাজার সমুহ',
		subtitle: 'হাজারো গ্রামীণ ঐতিহ্যবাহি বাজার থেকে কিনুন আপনার পন্য',
		breadcrumbLabel: 'বাজার',
		currentPlaceholder: 'খাবার খুজুন...'
	},
	filter: {
		title: 'ফিল্টার অপশন',
		searchPlaceholder: 'বাজার খুঁজুন...',
		district: 'জেলা',
		upazilla: 'উপজেলা',
		size: 'বাজারের আকার',
		sortBy: 'সাজান',
		sortOptions: {
			name: 'নাম অনুসারে',
			storeCount: 'দোকানের সংখ্যা',
			rating: 'রেটিং অনুসারে',
			visitors: 'জনপ্রিয়তা'
		},
		clearShort: 'ক্লিয়ার',
		clearAll: 'সব ক্লিয়ার',
		activeFilters: 'সক্রিয় ফিল্টার:',
		labels: {
			search: 'খোঁজ',
			district: 'জেলা',
			upazilla: 'উপজেলা',
			size: 'আকার'
		}
	},
	results: {
		foundSuffix: 'টি বাজার পাওয়া গেছে',
		none: 'কোনো বাজার পাওয়া যায়নি',
		page: 'পৃষ্ঠা'
	},
	empty: {
		title: 'আপনার অনুসন্ধানের সাথে মিলে এমন কোনো বাজার পাওয়া যায়নি',
		subtitle: 'অন্য ফিল্টার অপশন ব্যবহার করে দেখুন অথবা সব ফিল্টার ক্লিয়ার করুন',
		clear: 'সব ফিল্টার ক্লিয়ার করুন'
	},
	card: {
		stores: 'দোকান',
		dailyVisitors: 'দৈনিক দর্শক',
		specialties: 'বিশেষত্ব:',
		details: 'বিস্তারিত',
		visit: 'ভিজিট করুন'
	},
	dialog: {
		title: 'অভিনন্দন!',
		selected: 'আপনার  বাজার সিলেক্ট হয়েছে',
		instruction: 'এখন আপনার বর্তমান বাজার হিসেবে নির্বাচিত হয়েছে। আপনি যে ধরনের পণ্য কিনতে চান, নিচে থেকে সেই ক্যাটাগরি নির্বাচন করুন:',
		categoryPrompt: 'আপনি কি কেনাকাটা করতে চান?',
		bottomNotePrefix: 'এই পণ্যগুলি',
		bottomNoteSuffix: 'থেকে সংগ্রহ করা হবে',
		close: 'পরে দেখব'
	}
};

export default bazarListBn;


